module.exports = __webpack_public_path__ + "static/media/silver-ring.b9e8ca27.svg";